import { Icon } from '@components';
import { withFlexProps } from '@hocs';
import { Flex, Typography } from '@styles';
import { ReactComponent as CrossIcon } from '@svgs/close.svg';
import { bool, func, node } from 'prop-types';
import React from 'react';

import theme from '../../styles/theme';

const ClosableHint = ({ isOpen, onClose, text }) => {
  if (!isOpen) return null;

  return (
    <Flex
      background="rgba(255, 255, 255, 0.08)"
      borderRadius="8px"
      padding="6px"
    >
      <Typography
        color={theme.colors.white[100]}
        padding="10px"
        variant="MS-regular-s14-lh22"
      >
        {text}
      </Typography>
      <Icon
        height={24}
        onClick={onClose}
        style={{ cursor: 'pointer' }}
        SVG={CrossIcon}
        width={24}
      />
    </Flex>
  );
};

ClosableHint.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  text: node.isRequired,
};

export default withFlexProps(ClosableHint);
